export enum TransitionType {
	Default,
	None,
	Path,
	Flow,
	Answer
}
